import React from 'react'

import HeaderTopBar from './components/HeaderTopBar/HeaderTopBar.component'
import HeaderNavBar from './components/HeaderNavBar/HeaderNavBar.component'
import Breadcrumbs from './components/Breadcrumbs/Breadcrumbs.components'
import ComingSoon from './components/ComingSoon/ComingSoon.component'
import FooterContent from './components/FooterContent/FooterContent.component'
import FooterDisclaimer from './components/FooterDisclaimer/FooterDisclaimer.component'

import './Resources.page.scss'

class ResourcesPage extends React.Component {
  componentDidMount() {
    document.title = 'Resources | USA Benefits Group'
  }

  render() {
    return (
      <div id='ResourcesPage'>
        <HeaderTopBar />
        <HeaderNavBar />
        <Breadcrumbs items={[{ label: 'Home', href: '/' }, { label: 'Resources' }]} />
        <ComingSoon
          headline='Our Resources Hub Is On the Way'
          message='Tools, guides, and insights to help you navigate insurance with confidence — all in one place.'
        />
        <FooterContent />
        <FooterDisclaimer />
      </div>
    )
  }
}

export default ResourcesPage
